import { useSitecoreContext } from "@sitecore-jss/sitecore-jss-nextjs";
import * as Grid from "@repo/ui/grid";
import * as Viewport from "@/components/viewport";
import { ComponentProps } from "../../../../types/component-props";
import Placeholder from "../../../placeholder-component/placeholder";
import styles from "./container.module.css";

const Container = (props: ComponentProps): JSX.Element => {
  const placeholders = props.rendering?.placeholders || {};
  const { sitecoreContext } = useSitecoreContext();
  const isEditing = sitecoreContext?.pageEditing;

  if (!placeholders && !isEditing) {
    return <></>;
  }

  return (
    <div className={styles.container}>
      {placeholders &&
        Object.entries(placeholders).map(([key]) => {
          return (
            <div key={key}>
              <Viewport.Small>
                <Grid.Container columns={1} rowGap="xl">
                  <Placeholder name={key} rendering={props.rendering} />
                </Grid.Container>
              </Viewport.Small>
              <Viewport.Large>
                <Grid.Container
                  className={styles.mediumContainer}
                  columns={4}
                  columnGap="xl"
                  rowGap="xl"
                >
                  <Placeholder name={key} rendering={props.rendering} />
                </Grid.Container>
              </Viewport.Large>
            </div>
          );
        })}
    </div>
  );
};

export default Container;
